import { Title } from 'components';
import styled from 'styled-components';

export const Content = styled.div`
  @media screen and (min-width: 1186px) {
    .content-accordion {
      display: none;
    }
  }

  @media screen and (max-width: 1185px) {
    .content-accordion {
      margin-left: -20px;
      margin-right: -20px;
    }
  }
`;

export const TitleWrapper = styled.div`
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
  border-radius: 15px;
  margin-top: 40px;
  margin-bottom: 70px;
  padding: 20px;
`;

export const PageTitle = styled(Title)``;
